import Badge from 'react-bootstrap/Badge'
import { useTeamSpiritTable } from '../context/TeamSpiritTableContext'

const TeamSpiritSpecialRow = ({ row, rowCountryState }) => {
  const { countryGroups, nationalCompetition, worldCompetition, showUpdateDays, currentDateKey, styles, formatters, actions } = useTeamSpiritTable()
  const isReset = row.type === 'reset'
  if (!isReset && (!showUpdateDays || row.type !== 'update')) return null
  if (isReset && (!formatters.matchesCompetitionTargets(nationalCompetition, row.nationalTargets) || !formatters.matchesCompetitionTargets(worldCompetition, row.worldTargets))) return null
  const resetPercent = Number(((1 - Number(row.resetFactor || 0)) * 100).toFixed(0))
  const label = isReset ? <Badge bg="info" text="dark">{formatters.t('resetRow')} {resetPercent}%</Badge> : formatters.t('updateRow')
  const isCurrentUpdateDay = showUpdateDays && row.type === 'update' && formatters.toDateKey(row.date) === currentDateKey

  return <tr style={{ backgroundColor: isCurrentUpdateDay ? '#f4f0ff' : isReset ? '#e8f5ff' : '#fbfbfb', outline: isCurrentUpdateDay ? '2px solid #7c5cc4' : undefined, outlineOffset: isCurrentUpdateDay ? '-2px' : undefined }}>
    <td title={isReset ? 'Joukkuehengen resetti' : 'Päivittäinen joukkuehengen päivitys'} style={{ ...styles.compactCellStyle, fontWeight: 700, color: isReset ? undefined : '#667085' }}>{label}</td>
    <td title="Päivämäärä" style={{ ...styles.compactCellStyle, fontWeight: 700 }}>{formatters.formatDateLabel(row.date)}</td>
    {countryGroups.flatMap(country => {
      const state = rowCountryState[country] || {}
      const value = isReset
        ? <>{formatters.formatSpirit(state.spiritBeforeReset)} → {formatters.formatSpirit(state.spiritAfterReset)}</>
        : formatters.formatSpirit(state.spirit)
      return [
        <td key={`${row.key}-${country}-att`} title={isReset ? 'Joukkuehenki ennen ja jälkeen resetin' : 'Joukkuehenki päivittäisen päivityksen jälkeen'} style={actions.getCountryBandStyle(country, { ...styles.compactCellStyle, fontWeight: isReset ? 700 : 600 })}>{value}</td>,
        <td key={`${row.key}-${country}-mid`} title="Keskikenttäarvoa ei lasketa päivitys- tai resetti-riville" style={actions.getCountryBandStyle(country, { ...styles.compactCellStyle, color: '#667085' })}>—</td>,
      ]
    })}
  </tr>
}

export default TeamSpiritSpecialRow
